// src/services/jobService.ts
import api from '../Services/axiosConfig';
import { FlyerContent, JobDetail, JobsState } from '../types/job';

interface JobData {
  id?:string;
  title: string;
  description: string;
  AdditionalInformation: string;
  location: string;
  deadline: string;
  linkedinPost: string;
  screeningQuestions: string[];
  FlyerJobDescriptions: string[];
  FlyerJobSpecifications: string[];
  emailContent: string;
  jobKeywords: JobKeyword[];
}
interface FormData {
  jobId: string;
  jobTitle: string;
  jobDescription: string | string[];
  location: string;
  deadline: string;
  screeningQuestions: string[];
}

interface JD {
  id: string;
  title: string;
}
export interface JobKeyword {
  keyword: string;
  category: string;
  weight: number;
}
interface UpdateJobData {
  id: string;
  title: string;
  description: string;
  AdditionalInformation: string;
  location: string;
  deadline: string;
  linkedinPost: string;
  screeningQuestions: string[];
  FlyerJobDescriptions: string[];
  FlyerJobSpecifications: string[];
  emailContent: string;
  flyerimagePath?: string;
  jobKeywords?: JobKeyword[];
}

// Existing functions
export const fetchJobs = async (): Promise<JobsState> => {
  const response = await api.get('/jobs');
  const data = response.data;
  console.log(response.data)
  return {
    open: data.openJobs.map((job: { deadline: string; }) => ({
      ...job,
      deadline: job.deadline ? job.deadline: undefined
    })),
    inReview: data.inReviewJobs.map((job: { reviewStarted: any; }) => ({
      ...job,
      reviewStarted: job.reviewStarted || new Date().toLocaleString()
    })),
    closed: data.closedJobs.map((job: { closedDate: any; }) => ({
      ...job,
      closedDate: job.closedDate || new Date().toLocaleString()
    }))
  };
};

export const updateJobStatus = async (jobId: string, newStatus: string): Promise<void> => {
  try {
    await api.put(`/jobs/${jobId}/status`, { status: newStatus });
  } catch (error) {
    console.error('Failed to update job status:', error);
    throw error;
  }
};

export const getJobDetails = async (jobId: string) => {
  try {
    const response = await api.get(`/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch job details:', error);
    throw error;
  }
};

export const getJobApplications = async (jobId: string) => {
  try {
    const response = await api.get(`/jobs/${jobId}/applications`);
    console.log("the candidates", response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch job applications:', error);
    throw error;
  }
};

export const fetchJobDetails = async (jobId: string): Promise<JobDetail> => {
  const response = await api.get(`/jobs/${jobId}`);
  console.log(response.data);
  return response.data;
};

// New functions for PostNewJob component
export const fetchJDList = async (companyId: string) => {
  const response = await api.get(`/jobdescriptions/ListJDs/?companyId=${companyId}`);
  return response.data;
};

export const fetchJDContent = async (jdId: string) => {
  const response = await api.get(`/jobdescriptions/read/${jdId}`);
  return response.data.content;
};

export const createJob = async (jobData: JobData) => {
  const response = await api.post("/jobs", jobData);
  return response.data;
};

export const createApplicationForm = async (formData: FormData) => {
  const response = await api.post("jobs/forms/create", formData);
  return response.data;
};
export const deleteJob = async (jobId: string): Promise<void> => {
  try {
    await api.delete(`/jobs/${jobId}`);
  } catch (error) {
    console.error('Failed to delete job:', error);
    throw error;
  }
};
export const generateFlyer = async (jobId: string, formLink: string) => {
  const response = await api.get(
    `/jobs/generate?jobId=${jobId}&formLink=${encodeURIComponent(formLink)}`,
    { responseType: "json" }
  );
  return response.data;
};

export const updateFlyerContent = async (jobId: string, flyerContent: FlyerContent) => {
  const response = await api.put(`/jobs/${jobId}/flyer`, flyerContent);
  return response.data;
};

// Updated updateJob function to use the correct structure
export const updateJob = async (jobId: string, jobData: UpdateJobData) => {
  const response = await api.put(`/jobs/${jobId}`, jobData);
  return response.data;
};

export const improveJD = async (payload: { jdContent: string; whatToImprove: string }) => {
  const res = await api.post(`/jobs/improve-jd`, payload);
  return res.data.improvedJobDescription; // backend should return improved JD text
};

export const generateJobContent = async (payload: { companyBackground: string; jdContent: string; location: string; deadline: string }) => {
  const res = await api.post(`/jobs/generate-job-content`, payload);
  console.log(res.data);
  return res.data; // backend should return structured JSON
};
